<template>
  <div class="resident-warpper">
    <div class="bg-white">
      <div class="flex align-center justify-between">
        <div >
          <div class="flex align-center  margin-bottom-sm">
            <div class="flex align-center margin-right-sm ">
              <span>角<i style="padding-left: 14px;"></i>色：</span>
              <el-select v-model="user_type" placeholder="请选择" class="flex-sub" @change="setType">
                <el-option label="全部" value=""></el-option>
                <el-option label="志愿者队长" :value="1"></el-option>
                <el-option label="志愿者" :value="2"></el-option>
                <el-option label="居民" :value="3"></el-option>
              </el-select>
            </div>
            <div class="flex align-center margin-right-sm ">
              <span>姓名：</span>
              <el-input v-model="searchName" placeholder="请输入姓名" class="flex-sub"></el-input>
            </div>
            <div class="flex align-center margin-right-sm ">
              <span>手机号：</span>
              <el-input v-model="searchPhone" placeholder="请输入手机号" class="flex-sub"></el-input>
            </div>
          </div>


          <fiveLevel @upFive="upFive" :sproject="project" :scommunity="community" v-if="user_type === 3"/>

        </div>
        <el-button type="primary" @click="hanldSearch">搜索</el-button>
      </div>

      <div class="flex align-center justify-between margin-tb-sm">
        <div>
          共{{ total }}条数据
        </div>
        <div>
        </div>
      </div>
      <el-table
        :data="list"
        header-row-class-name="table-header"
        row-class-name="table-row"
        alig="center"
        border
        style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (page - 1) * 10 }}
          </template>
        </el-table-column>
        <el-table-column width="70" type="index" align="center" label="总排名">
          <template slot-scope="scope">
            {{ scope.row.rank_num }}
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="name"></el-table-column>
        <el-table-column label="联系电话" prop="phone"></el-table-column>
        <el-table-column label="类型" prop="user_type">
          <template slot-scope="scope" >
            <div>
              {{scope.row.user_type ===1?'志愿者队长': scope.row.user_type ===2?'志愿者':'居民' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="社区" prop="xiangmu_name"></el-table-column>
        <el-table-column label="小区" prop="xiaoqu_name"></el-table-column>
        <el-table-column label="房间号">
          <template slot-scope="scope" v-if="scope.row.user_type ===3">
            <div>
              {{ scope.row.building_name }}-{{scope.row.element_name}}-{{scope.row.room_name}}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="参与竞赛次数" prop="race_num" ></el-table-column>
      </el-table>
      <el-pagination
        v-if="list.length > 0"
        class="page-all"
        background
        @current-change="getList"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>

import fiveLevel from '@/components/five-level'
import { getSystemRanking} from "@/api/study";

export default {
  name: "ranking-list",
  data() {
    return {
      user_type: '',
      searchName: '',
      searchPhone: '',
      project: 0,
      community: 0,
      building: 0,
      unit: 0,
      room: 0,
      page: 1,
      limit: 10,
      total: 0,
      list: [],
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.$emit("setIndex", this.$route.path, "双暖为老 / 系统排名", false);
    this.getList()
  },
  components: {
    fiveLevel
  },
  methods: {
    setType(){
      this.project = ''
      this.community = ''
      this.building =''
      this.unit = ''
      this.room = ''
    },
    //  同步更新五级联动
    upFive(val) {
      this.project = val.project
      this.community = val.community
      this.building = val.building
      this.unit = val.unit
      this.room = val.room
    },
    //  搜索
    hanldSearch() {
      this.page = 1
      this.getList()
    },
    //  获取列表
    async getList() {
      const res = await getSystemRanking(this.user_type,this.searchName,this.searchPhone,this.project,this.community,this.building,this.unit,this.room)
      if(res.status === 200){
        this.list = res.data
        this.total = res.total_number
      }else{
        this.list =[]
        this.total = 0
      }
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
